import Geohash from './latlon-hash';
export function getGeoHashPolygon(hash) {
    // 西南, 东北点坐标
    if (!hash || typeof hash !== 'string')
        return;
    const { sw, ne } = Geohash.bounds(hash);
    if (!sw || !ne)
        return;
    return [
        [
            [sw.lon, sw.lat],
            [sw.lon, ne.lat],
            [ne.lon, ne.lat],
            [ne.lon, sw.lat],
            [sw.lon, sw.lat],
        ],
    ];
}
